import { Table, Pagination, Button, Popconfirm, Tooltip } from "antd";
import { EditOutlined, DeleteOutlined, EyeOutlined } from "@ant-design/icons";
import moment from "moment";

function DataTable(props) {
  const columns = [
    {
      title: "Voucher ID",
      dataIndex: "id",
      key: "voucher_id",
      render: (text, record) => (
        <strong>{`CV-${String(record.id).padStart(5, "0")}`}</strong>
      ),
    },
    {
      title: "Date",
      dataIndex: "voucher_date",
      key: "voucher_date",
      render: (text) => <span>{moment(text).format("DD-MM-YYYY")}</span>,
    },
    {
      title: "Ledger From",
      dataIndex: "ledger_from",
      key: "ledger_from",
      render: (text, record) =>
        `${record.ledger_from} - ${record.fromAccount?.account_name || ""}`,
    },
    {
      title: "Ledger To",
      dataIndex: "ledger_to",
      key: "ledger_to",
      render: (text, record) =>
        `${record.ledger_to} - ${record.toAccount?.account_name || ""}`,
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (text) => <span>{text}</span>,
    },
    {
      title: "",
      key: "action",
      render: (item) => (
        <div className="tableAction">
          <Tooltip title="View">
            <Button
              size="small"
              icon={<EyeOutlined />}
              onClick={() => props.view(item)}
              style={{ marginRight: 10 }}
            />
          </Tooltip>
          <Tooltip title="Edit">
            <Button
              size="small"
              onClick={() => props.update(item)}
              icon={<EditOutlined />}
              style={{ marginRight: 10 }}
            />
          </Tooltip>
          <Popconfirm
            placement="bottomRight"
            title={"Are you sure to delete?"}
            okText="Yes"
            cancelText="No"
            onConfirm={() => props.delete(item)}
          >
            <Tooltip title="Delete">
              <Button danger size="small" icon={<DeleteOutlined />} />
            </Tooltip>
          </Popconfirm>
        </div>
      ),
    },
  ];

  return (
    <div style={{ minHeight: "60vh" }}>
      <Table
        columns={columns}
        dataSource={props.data || []}
        pagination={false}
        size="small"
      />
      <br />
      <h6>Total: {props.meta?.itemCount || 0} Contras</h6>
      <div align="right">
        <Pagination
          current={props.meta?.page || 1}
          total={props.meta?.itemCount || 0}
          pageSize={props.meta?.take || 10}
          onChange={(page, pageSize) => props.PageOnchange(page, pageSize)}
          pageSizeOptions={[10, 20, 50]}
          showSizeChanger
          showTotal={(total, range) =>
            `${range[0]}-${range[1]} of ${total} items`
          }
        />
      </div>
    </div>
  );
}

export default DataTable;
